import React, { Suspense, lazy } from "react";
import { GlobalStyle } from "./Styles/global";
import { ThemeProvider } from "styled-components";
import { useTheme } from "./Context/ThemeContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebaseConfig";
import { CircularProgress } from "@mui/material";

// Lazy load pages for better performance
const HomePage = lazy(() => import("./Pages/HomePage"));
const UserPage = lazy(() => import("./Pages/UserPage"));
const LoginPage = lazy(() => import("./Pages/LoginPage"));
const LeaderboardPage = lazy(() => import("./Pages/LeaderboardPage"));

const FullPageLoader = () => {
  const { theme } = useTheme();
  return (
    <div 
        style={{ 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100vw',
            background: theme.background,
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 9999
        }}
    >
      <CircularProgress size={"5rem"} style={{ color: theme.typeBoxText }} />
    </div>
  );
};

function App() {
  const { theme } = useTheme();
  const [user, loading] = useAuthState(auth);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ToastContainer />
      <Suspense fallback={<FullPageLoader />}>
        {loading ? (
            <FullPageLoader />
        ) : (
            <Routes>
                <Route path="/" element={!user ? <LoginPage /> : <Navigate to="/home" />} />
                <Route path="/home" element={user ? <HomePage /> : <Navigate to="/" />} />
                <Route path="/user" element={user ? <UserPage /> : <Navigate to="/" />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        )}
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
